import React from 'react'
import { Container, Wrapper, Arrow } from './components/Styled'

interface LabelProps {
  isSale?: boolean
  isUsed?: boolean
  position?: number
}

export const Label: React.FC<LabelProps> = ({ isSale, isUsed, children, position= 1 }) => {
  return (
    <Container position={position}>
      <Wrapper
        sale={isSale}
        used={isUsed}
      >
        {children}
      </Wrapper>
      <Arrow
        sale={isSale}
        used={isUsed}
      />
    </Container>
  )
}
